import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=aeefbbec&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=aeefbbec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeefbbec",
  null
  
)

export default component.exports